export const PADDING = 16;
export const ON_SCREEN_THRESHOLD = 32;
export const SEGMENT_DIVIDER_WIDTH = 43;
export const SHADOW_BREATHING_ROOM = 36;
